import { apiFetch, apiFetchWithRetry } from '@/lib/apiFetch';
import { handleUnauthorized } from './UserManagmentServices';
import type { GoalProfileRequest, GoalProfileResponse } from '@/types/goalProfile';
import type { GoalHistoryEntry } from '@/types/registeredStudent';

export async function upsertGoalProfile(
  accessToken: string,
  data: GoalProfileRequest
): Promise<GoalProfileResponse> {
  const response = await apiFetch('/api/userManagement/v1/me/goal-profile', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${accessToken}`,
    },
    body: JSON.stringify(data),
  });
  if (response.status === 401) handleUnauthorized();
  if (!response.ok) throw new Error(`Failed to save goal profile: ${response.status}`);
  return response.json();
}

export async function getGoalProfile(accessToken: string): Promise<GoalProfileResponse> {
  const response = await apiFetchWithRetry('/api/userManagement/v1/me/goal-profile', {
    method: 'GET',
    headers: {
      'Authorization': `Bearer ${accessToken}`,
    },
  });
  if (response.status === 401) handleUnauthorized();
  if (response.status === 404) throw new Error('GOAL_PROFILE_NOT_FOUND');
  if (!response.ok) throw new Error(`Failed to fetch goal profile: ${response.status}`);
  return response.json();
}

export async function getGoalHistory(accessToken: string): Promise<GoalHistoryEntry[]> {
  const response = await apiFetchWithRetry('/api/userManagement/v1/me/goal-history', {
    method: 'GET',
    headers: {
      'Authorization': `Bearer ${accessToken}`,
    },
  });
  if (response.status === 401) handleUnauthorized();
  if (!response.ok) throw new Error(`Failed to fetch goal history: ${response.status}`);
  return response.json();
}
